var $00a415a3f0ab315a$exports = {};
$00a415a3f0ab315a$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rimuokkain`,
    "colorSwatch": `v\xe4rimalli`,
    "transparent": `l\xe4pin\xe4kyv\xe4`,
    "twoDimensionalSlider": `2D-liukus\xe4\xe4din`
};


export {$00a415a3f0ab315a$exports as default};
//# sourceMappingURL=fi-FI.module.js.map
